export default __webpack_public_path__ + "static/media/Arri_Stufenlinse_01.c98ebd81.webp";